import ProviderCapabilities from "../../ProviderCapabilities";
import FunctionAuthProvider from "./FunctionAuthProvider";

var FunctionCredential = function () {
  function FunctionCredential(payload, providerName) {
    if (providerName === void 0) {
      providerName = FunctionAuthProvider.DEFAULT_NAME;
    }

    this.providerType = FunctionAuthProvider.TYPE;
    this.providerName = providerName;
    this.material = payload;
  }

  Object.defineProperty(FunctionCredential.prototype, "providerCapabilities", {
    get: function get() {
      return new ProviderCapabilities(false);
    },
    enumerable: true,
    configurable: true
  });
  return FunctionCredential;
}();

export default FunctionCredential;